/** 
  @Time: 2023/08/25-11:35
 
  @File: request.js
  @Software: vscode
  @Description: axios封装
*/
import axios from 'axios'
import router from '@/router';
import { ElNotification } from 'element-plus'
import {send} from '@/utils/lang_change.js'



//1. 创建新的axios实例
const service = axios.create({
  // baseURL:"",
  timeout: 5000
})
// 2.请求拦截器
service.interceptors.request.use(config => {
  let token = localStorage.getItem('token');
  if (token) {
    config.headers['Authorization'] = token;
  }
  config.headers['Accept-Language'] = send(sessionStorage.getItem('lang'));
  return config
}, error => {
  Promise.reject(error)
})

// 3.响应拦截器
service.interceptors.response.use(response => {
  // console.log('response',response)
  return response
}, error => {
  if (error && error.response) {
    switch (error.response.status) {
      case 400:
        error.message = 'Request Error';
        break;
      case 401:
        sessionStorage.clear();
        localStorage.clear();
        ElNotification({
          title: 'error',
          message: "Login expired",
          type: 'error',
        })
        router.push('/login');
        error.message = 'Login expired';
        break;
      case 403:
        error.message = 'No access'
        break;
      case 404:
        error.message = 'Request error, the resource was not found'
        break;
      case 405:
        error.message = 'Request method not allowed'
        break;
      case 408:
        error.message = 'Request timeout'
        break;
      case 500:
        error.message = 'Server side error'
        break;
      case 501:
        error.message = 'Network not implemented'
        break;
      case 502:
        error.message = 'Network error'
        break;
      case 503:
        error.message = 'The service is unavailable'
        break;
      case 504:
        error.message = 'Network Timeout'
        break;
      case 505:
        error.message = 'The HTTP version does not support this request'
        break;
      default:
        error.message = 'Connection error'
    }
  }
  return Promise.resolve(error.response)
})
//4.导入文件
export default service
